<template>
  <b-row v-if="analytics_loaded && (!is_marketplace || is_multi_site_manager)" class="m-0 pr-2 pl-2">
    <b-container fluid class="white-box">
      <highcharts :options="chartOptions"></highcharts>
    </b-container>
  </b-row>
  <b-row v-else-if="!is_marketplace || is_multi_site_manager" class="m-0 pr-2 pb-2 pl-2">
    <analytics-loader/>
  </b-row>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'
import AnalyticsLoader from '@/components/AnalyticsLoader.vue';

export default {
  components: {
    AnalyticsLoader
  },
  computed: {
    analytics_loaded() { return this.$store.getters.analytics_loaded },
    is_multi_site_manager() { return this.$store.getters.is_multi_site_manager },
    is_marketplace() { return this.$store.getters.is_marketplace },
    line_data_page_views () { return this.$store.getters.line_data_page_views },
    visits_page_views () { return this.$store.getters.visits_page_views },
    chartOptions() {
      const pageViewsData = this.line_data_page_views;
      const visitsData = this.visits_page_views;

      // datas para este gráfico (xAxis)
      const datesArray = [];
      visitsData.forEach(element => {
        // substring remove o dia da semana que deixava feio o axis
        datesArray.push(element[0].substring(0, 8))
      });

      return {
        title: {
          text: 'Visitas na loja:'
        },
        xAxis: {
          labels: {
            formatter: function() {
              return datesArray[this.value]
            }
          }
        },
        yAxis: [{ // left y axis
          title: {
            text: null
          },
          labels: {
            align: 'left',
            x: 3,
            y: 16,
            format: '{value:.,0f}'
          },
          showFirstLabel: false
        }, { // right y axis
          linkedTo: 0,
          gridLineWidth: 0,
          opposite: true,
          title: {
            text: null
          },
          labels: {
            align: 'right',
            x: -3,
            y: 16,
            format: '{value:.,0f}'
          },
          showFirstLabel: false
        }],
        legend: {
          align: 'left',
          verticalAlign: 'top',
          borderWidth: 0
        },
        tooltip: {
          shared: true,
          crosshairs: true
        },
        series: [{
          name: 'visualizações de página',
          color: '#7ABA1E',
          data: pageViewsData
        }, {
          name: 'visitas únicas',
          color: '#0BA7DA',
          data: visitsData
        }],
      }
    }
  }
}
</script>

<style>

</style>
